export default __webpack_public_path__ + "static/media/umang-logo-v1.2c3857ae.png";